import {
  useLocation, useNavigate, useParams, useSearchParams,
} from 'react-router-dom';
import { getSearchParamsAsObject } from '../../../../ui-kitchen/src/utils/locationUtils';
import { getURLSearchParams, setSearchParams } from '../../../../ui-kitchen/src/utils/searchParamUtils';

// Shim for $routeParams
const useRouteParams = () => {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const searchParamsObject = getSearchParamsAsObject(searchParams);
  // honors Angular.js contract where same-key path params override search params
  return { ...searchParamsObject, ...params };
};

// Shim for $route.updateParams()
// This seems to be used only for :location dynamic parameter
const useUpdateParams = (paramsToUpdate = {}) => {
  const dynamicParams = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname, search } = location;

  const updateEntries = Object.entries(paramsToUpdate);
  const updateEntriesLength = updateEntries.length;

  const dynamicEntries = Object.entries(dynamicParams);
  const dynamicEntriesLength = dynamicEntries.length;

  // check for dynamic path segment match
  for (let i = 0; i < updateEntriesLength; i += 1) {
    const [updateKey, updateValue] = updateEntries[i];

    for (let j = 0; j < dynamicEntriesLength; j += 1) {
      const [dynamicKey, dynamicValue] = dynamicEntries[j];
      /* istanbul ignore else */
      if (updateKey === dynamicKey && updateValue !== dynamicValue) {
        const newPathname = pathname.replace(dynamicValue, updateValue);
        const newRoute = `${newPathname}${search}`;
        navigate(newRoute);
        return;
      }
    }
  }

  // check for search param match
  const searchParams = getURLSearchParams();
  for (let i = 0; i < updateEntriesLength; i += 1) {
    const [updateKey, updateValue] = updateEntries[i];

    /* istanbul ignore else */
    if (searchParams.has(updateKey)) {
      setSearchParams(updateKey, updateValue);
      return;
    }
  }
};

// Shim for $rootScope.hasLocalStorageSupport
const hasLocalStorageSupportShim = (global = window) => {
  let hasLocalStorageSupport = 'localStorage' in global;

  /* istanbul ignore else */
  if (hasLocalStorageSupport) {
    const testKey = 'resy.translate.storageTest';

    try {
      // this check have to be wrapped within a try/catch because on
      // a SecurityError: Dom Exception 18 on iOS
      if (global.localStorage !== null) {
        global.localStorage.setItem(testKey, 'foo');
        global.localStorage.removeItem(testKey);
        hasLocalStorageSupport = true;
      } else {
        hasLocalStorageSupport = false;
      }
    } catch (e) {
      hasLocalStorageSupport = false;
    }
  }
  return hasLocalStorageSupport;
};

export {
  // eslint-disable-next-line import/prefer-default-export
  hasLocalStorageSupportShim,
  useRouteParams,
  useUpdateParams,
};
